"use client";

import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  CartesianGrid,
} from "recharts";

import { ChartTooltipContent, ChartContainer } from "../ui/chart";
import { BoxContainerChart } from "./styles";

export interface HorizontalBarItem {
  name: string;
  value: number;
}

type Props = {
  data: HorizontalBarItem[];
  nameKey?: string;
  valueKey?: string;
  title?: string;
  color?: string;
  height?: number;
  valueFormatter?: (v: any) => string;
};

const HorizontalBarChart: React.FC<Props> = ({
  data,
  nameKey = "name",
  valueKey = "value",
  title,
  color = "#0f4c81",
  height = 360,
  valueFormatter,
}) => {
  const values = (data || []).map((d) => Number(d.value || 0));
  const maxValue = values.length ? Math.max(...values) : 0;
  const formattedData = (data || []).map((d) => ({
    ...d,
    _background: maxValue,
  }));

  return (
    <BoxContainerChart
      config={{ y: { color } }}
      className="w-full items-center"
    >
      <div className="w-full " style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            layout="vertical"
            data={formattedData}
            margin={{ top: 10, right: 30, left: 30, bottom: 10 }}
          >
            <CartesianGrid vertical={false} strokeDasharray="3 3" />
            <XAxis type="number" tickLine={false} axisLine={false} />
            <YAxis
              dataKey={nameKey}
              type="category"
              width={220}
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 14 }}
            />
            <Tooltip
              cursor={false}
              content={
                <ChartTooltipContent
                  hideLabel
                  nameKey={nameKey}
                  formatter={(val: any) =>
                    valueFormatter ? valueFormatter(val) : val
                  }
                />
              }
            />
            {/* background full-length light bars */}
            <Bar
              dataKey="_background"
              fill="#eef2f7"
              radius={[6, 6, 6, 6]}
              isAnimationActive={false}
            />
            {/* actual animated bars on top */}
            <Bar
              dataKey={valueKey}
              fill={color}
              radius={[6, 6, 6, 6]}
              animationDuration={900}
              animationEasing="ease-out"
            >
              <LabelList
                dataKey={valueKey}
                position="insideRight"
                formatter={(v: any) =>
                  valueFormatter
                    ? valueFormatter(v)
                    : v !== undefined
                      ? v.toLocaleString()
                      : v
                }
                fill="#fff"
                style={{ fontSize: 12 }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </BoxContainerChart>
  );
};

export default HorizontalBarChart;
